<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="profile-heading position-relative">
        <div class="profile-heading__settings-btn" (click)="editProfile()">
          <img src="assets/img/settings.svg" alt="Settings" class="pe-2"> {{ t('app.user.profile.settings') }}
        </div>
        <div class="me-40">
          <div class="avatar-wrapper">
            <div class="el-1">
              <div>
                <input type="file" accept="image/*" #file (change)="processFile(file)">
                @if(profilePicture){
                  <button class="avatar-button" (click)="file.click()">
                    <img [src]="profilePicture" class="avatar" alt="Avatar">
                  </button>
                }@else {
                  <button class="avatar-button" (click)="file.click()">
                    <img src="assets/img/blank_profile.webp" class="avatar" alt="Avatar">
                  </button>
                }
              </div>
            </div>
            @if(profilePicture&&editProfilePictureMode){
              <div class="el-2">
                <button (click)="onDeleteProfilePicture()" class="btn shadow btn-circle red-btn">
                  <i class="bi bi-x-lg bold"></i>
                </button>
              </div>
            }
           @if(editProfilePictureMode){
            <div class="el-3">
              <input type="file" accept="image/*" #file (change)="processFile(file)">
              <button (click)="file.click()" class="btn shadow btn-circle black-btn">
                <i class="bi bi-upload bi-bold"></i>
              </button>
            </div>
           }@else {
            <div class="el-3">
              <button type="button" (click)="onEditProfilePicture()" class="btn shadow btn-circle red-btn">
                <i class="bi bi-pencil-fill"></i>
              </button>
            </div>
           }
          </div>
        </div>
        <div class="d-flex w-100 justify-content-between align-items-center">
          <div>
            <span class="usr-name">{{
              ((currentUserDetails?.firstname ?? "")| titlecase) + " " + ((currentUserDetails?.lastname ?? "") |
              titlecase)
              }}
            </span>
            @if(currentUserDetails?.city || currentUserDetails?.country){
              <div class="country">
                <span>{{ (currentUserDetails?.city ?? "" | titlecase) }}</span>
                <span>{{
                  (currentUserDetails?.city &&
                  currentUserDetails?.country ? "," : "")
                  }}</span>
                <span> {{
                  (currentUserDetails?.country ? (getCountryName() |
                  titlecase) : "")
                  }}</span>
              </div>
            }
          </div>
          <div class="">
            <app-search [searchBarClass]="'extra-small'" [placeholder]="t('explore.search')" />
          </div>
        </div>
      </div>
      <div class="vertical-separator"></div>
      <div class="nav-bar-padding pb-300-228">
        <app-nav-tabs [reduceHorizontalSpacing]="true">
          <app-nav-tab [title]="t('app.user.profile.my.dashboard')" [itemId]="1">
            <ng-template>
              <div class="pt-62-32">
                <app-user-profile-dashboard-tab [raceUpcomingEvents]="raceUpcomingEvents"
                  [favoriteItems]="favoriteItems" [languages]="languages" [countries]="countries" [page]="1"
                  [pageSize]="10" [races]="finishedRaces" [raceResultsMap]="raceResultsMap"
                  [currentUserDetails]="currentUserDetails" [unreadMessages]="unreadMessages" [users]="users" />
              </div>
            </ng-template>
          </app-nav-tab>
          <app-nav-tab [title]="t('app.user.profile.my.results')" [itemId]="2">
            <ng-template>
              <div class="pt-62-32">
                My results content
              </div>
            </ng-template>
          </app-nav-tab>
          <app-nav-tab [title]="t('app.user.profile.my.events')" [itemId]="3">
            <ng-template>
              <div class="pt-62-32">
                <app-user-profile-events-tab [languages]="languages" />
              </div>
            </ng-template>
          </app-nav-tab>
          <app-nav-tab [title]="t('app.user.profile.my.wish.list')" [itemId]="4">
            <ng-template>
              <div class="pt-62-32">
                <app-user-profile-wish-list-tab [favoriteItems]="favoriteItems" [languages]="languages" [countries]="countries"/>
              </div>
            </ng-template>
          </app-nav-tab>
          <app-nav-tab [title]="t('app.user.profile.my.leagues')" [itemId]="5">
            <ng-template>
              <div class="pt-62-32">
                My leagues
              </div>
            </ng-template>
          </app-nav-tab>
          <app-nav-tab [title]="t('app.user.profile.my.clubs.and.teams')" [itemId]="6">
            <ng-template>
              <div class="pt-62-32">
                <app-user-profile-clubs-and-teams-tab />
              </div>
            </ng-template>
          </app-nav-tab>
          <app-nav-tab [title]="t('app.user.profile.my.coupons')" [itemId]="7">
            <ng-template>
              <div class="pt-62-32">
                My coupons content
              </div>
            </ng-template>
          </app-nav-tab>
        </app-nav-tabs>
      </div>
    </div>
    <app-footer />
  </app-page-template>
  <ng-template #basicData>
    <div class="d-flex pt-3  pb-3 px-3 flex-md-row basic-data-header">
      <p class="fs-13-px fw-bolder fade-out">{{ t("app.user.profile.basic.data") | uppercase }}
      <p>
    </div>
    <div class="d-flex py-3 px-3 flex-md-row basic-data-row ">
      <i class="bi bi-calendar-date fade-out"></i>
      <div class="px-2 d-flex flex-column fade-out font-sizing__12">
        <p>{{ t("app.common.birthDay") }}</p>
        <span class="fs-12-px fw-bolder">
          {{ currentUserDetails?.birthDay ?? "" | date }}
        </span>
      </div>
    </div>
    <div class="d-flex py-3 px-3 flex-md-row basic-data-row">
      <i class="bi-gender-ambiguous fade-out"></i>
      <div class=" px-2 d-flex flex-column fade-out font-sizing__12">
        <p>{{ t("app.common.gender") }}</p>
        <span class="fs-12-px fw-bolder">
          {{
          currentUserDetails?.gender ? t("app.common.gender." +
          currentUserDetails?.gender) : "-"
          }}
        </span>
      </div>
    </div>
    <div class="d-flex py-3 px-3 basic-data-row">
      <i class="bi bi-envelope fade-out basic-data-row"></i>
      <div class=" px-2 d-flex flex-column fade-out font-sizing__12">
        <p>{{ t("app.common.email") }}</p>
        <span class="fs-12-px fw-bolder">
          {{ currentUserDetails?.email ?? "" }}
        </span>
      </div>
    </div>
    <div class="d-flex py-3 px-3 flex-md-row">
      <i class="bi bi-telephone fade-out"></i>
      <div class="px-2 d-flex flex-column fade-out font-sizing__12">
        <p>{{ t("app.common.mobilePhone") }}</p>
        <span class="fs-12-px fw-bolder">
          {{ currentUserDetails?.phoneNumber ?? "" }}
        </span>
      </div>
    </div>
  </ng-template>
</ng-container>
